import React from "react";

export const Photos = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={200}
            height={156}
            viewBox="0 0 200 156"
            fill="none"
            {...props}
        >
            <g opacity={0.9}>
                <path fill="#157BF2" d="M29 45H79V143H29z" />
                <path fill="#299BEF" d="M36 45H72V143H36z" />
                <rect x={31} y={47} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={52} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={57} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={62} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={67} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={72} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={77} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={82} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={87} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={92} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={97} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={102} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={107} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={112} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={117} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={122} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={127} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={132} width={3} height={3} rx={1} fill="#fff" />
                <rect x={31} y={137} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={47} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={52} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={57} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={62} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={67} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={72} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={77} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={82} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={87} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={92} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={97} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={102} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={107} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={112} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={117} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={122} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={127} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={132} width={3} height={3} rx={1} fill="#fff" />
                <rect x={74} y={137} width={3} height={3} rx={1} fill="#fff" />
                <path fill="#EEF8FF" d="M36 75H72V76H36z" />
                <path fill="#EEF8FF" d="M36 110H72V111H36z" />
                <path
                    d="M94.011 33.803l11.647 43.467 48.296-12.94-11.646-43.468-48.297 12.942z"
                    fill="#1360BA"
                />
                <path
                    d="M102.705 50.34l5.694 21.25 39.603-10.612-5.694-21.25-39.603 10.611zM128.204 33.911c.834 3.208 4.081 5.14 7.29 4.306a6.008 6.008 0 004.327-7.3 6.01 6.01 0 00-7.303-4.325c-3.21.833-5.147 4.111-4.314 7.32zM99.945 40.495l.518 1.932 26.08-6.988-.518-1.932-26.08 6.989zM98.91 36.632l.518 1.932 26.08-6.988-.518-1.932-26.08 6.988zM100.981 44.36l.518 1.931 26.08-6.988-.518-1.932-26.08 6.988z"
                    fill="#F5F9FC"
                />
                <path
                    d="M145.768 59.057l-35.515 9.477 2.165-15.512 10.275 6.72 3.822-13.175 9.773 7.41 2.418-3.563 7.062 8.643z"
                    fill="#55C7A6"
                />
                <path d="M113.911 28.323v45h50v-45h-50z" fill="#157BF2" />
                <path
                    d="M118.029 46.546v22h41v-22h-41zM146.912 37.277c-.025 3.315 2.611 6.02 5.926 6.046a6.007 6.007 0 006.069-5.931 6.01 6.01 0 00-5.935-6.068c-3.315-.026-6.035 2.64-6.06 5.953zM117.911 36.324v2h27v-2h-27zM117.911 32.324v2h27v-2h-27zM117.911 40.324v2h27v-2h-27z"
                    fill="#F5F9FC"
                />
                <path
                    d="M157.368 66.113l-36.757-.039 6.106-14.422 8.185 9.15 7.102-11.738 7.522 9.687 3.258-2.815 4.584 10.177z"
                    fill="#55C7A6"
                />
                <path
                    d="M133.587 28.62L121.94 72.086l48.296 12.941 11.647-43.466-48.296-12.941z"
                    fill="#299BEF"
                />
                <path
                    d="M132.848 47.287l-5.694 21.25 39.603 10.612 5.694-21.25-39.603-10.612zM163.145 45.81c-.882 3.195.964 6.49 4.16 7.373a6.008 6.008 0 007.398-4.158 6.011 6.011 0 00-4.163-7.398c-3.196-.882-6.513.988-7.395 4.183zM135.38 37.383l-.518 1.931 26.08 6.988.518-1.931-26.08-6.989zM136.415 33.519l-.517 1.932 26.08 6.988.517-1.932-26.08-6.988zM134.345 41.246l-.518 1.932 26.08 6.988.518-1.932-26.08-6.988z"
                    fill="#F5F9FC"
                />
                <path
                    d="M165.782 76.369l-35.495-9.55 9.631-12.352 5.538 10.958 9.898-9.5 4.759 11.303 3.876-1.875 1.793 11.016z"
                    fill="#55C7A6"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M73.724 143h108.5v-6H149.37l-13.403-43.362A8 8 0 00128.324 88H68.79c-5.303 0-9.138 5.066-7.7 10.17L73.724 143z"
                    fill="#32393E"
                />
                <circle cx={148.33} cy={113.5} r={14} fill="#FE9235" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M149.33 106.5h-2v6h-6v2h6v6h2v-6h6v-2h-6v-6z"
                    fill="#fff"
                />
            </g>
        </svg>
    )
}
